const { CrudModel } = require('./crud');

export class AccountPayableModel extends CrudModel {
	constructor() {
		super('admin/account_payable', []);
	}

	async importCsv(csv: string) {
		return this.executeAction(null, "importCsv", { csv });
	}
}

export default new AccountPayableModel();
